import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

    yogas=[
      {
        img:"assets/images/yoga-img/girl-1050x640.png",
        des1:"right way",
        des2:"yoga",
        des3:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        btn:"read more"
      },
      // {
      //   img:"assets/images/yoga-img/girl-1050x640.png",
      //   des1:"right way",
      //   des2:"yoga",
      //   des3:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
      //   btn:"read more"
      // }
    ]

    homeCarouselOptions={
      items: 1,
      margin: 0,
      width: '100',
      nav: false,
      loop: false,
      dots: false,
      responsive: {
        0: {
            items: 2
        }
    }
    }

    readMore() {
      const element = document.querySelector("#about");
      if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
